import { render, staticRenderFns } from "./ProgressStatementDetailsCard.vue?vue&type=template&id=877f10ea"
import script from "./ProgressStatementDetailsCard.vue?vue&type=script&lang=ts"
export * from "./ProgressStatementDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports